// react
import React from "react";

interface props {
	distance: number;
}

export const Spacer = (props: props) => {
	return <div style={{ width: props.distance, height: props.distance }} />;
};
